import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FullFeedbackAlertType } from 'src/app/models/enums/full-feedback-alert-type';

export interface FullFeedbackAlertData {
	type: FullFeedbackAlertType;
	title: string;
	messages: string[];
	error_msg?: string[];
	confirm?: boolean;
	positive?: string;
	positiveIcon?: string;
	negative?: string;
	negativeIcon?: string;
	requiredReason?: boolean;
	requiredRefNo?: boolean;
	isRequiredDocument?: boolean;
	alignLeft?: boolean;
}

@Component({
	selector: 'app-full-feedback-alert',
	templateUrl: './full-feedback-alert.component.html',
	styleUrls: ['./full-feedback-alert.component.scss']
})
export class FullFeedbackAlertComponent implements OnInit {

	descriprion: UntypedFormControl;
	ref_desc: UntypedFormControl;
	other_desc: UntypedFormControl;
	supporting_docs: UntypedFormArray;

	readonly TYPE = FullFeedbackAlertType; // FOR NO MODIFY TO THE ENUM
	constructor(
		private dialogRef: MatDialogRef<FullFeedbackAlertComponent>,
		@Inject(MAT_DIALOG_DATA) public data: FullFeedbackAlertData
	) {
		this.descriprion = new UntypedFormControl(null, Validators.required);
		this.ref_desc = new UntypedFormControl(null, Validators.required);
		this.other_desc = new UntypedFormControl(null, Validators.required);
		this.supporting_docs = new UntypedFormArray([], Validators.required);
	}

	ngOnInit(): void {
		this.initialize();
	}

	async initialize(): Promise<void> {
		this.dialogRef.addPanelClass(['animate__animated', 'animate__slideInUp', 'animate__faster']);
		await this.dialogRef.beforeClosed().toPromise();
		this.dialogRef.removePanelClass(['animate__animated', 'animate__slideInUp', 'animate__faster']);
		this.dialogRef.addPanelClass(['animate__animated', 'animate__fadeOutDown', 'animate__faster']);
	}

	onUploadDocument(e: Event) {
		let input = e.target as HTMLInputElement;
		if (!input.files) return;

		for (let i = 0; i < input.files.length; i++) {
			const file = input.files[i];
			this.supporting_docs.push(
				new UntypedFormControl({
					file: file,
					filename: file.name,
					contentType: file.type
				}, Validators.required)
			);
		}

		input.value = "";
	}

	deleteFile(index: number) {
		this.supporting_docs.removeAt(index);
	}

	onSubmit() {
		let result: any = null;

		if (this.data.requiredRefNo) {
			result = {
				ref_desc: this.ref_desc.value,
				desc: this.descriprion.value,
				other_desc: this.other_desc.value
			};
		} else if (this.data.requiredReason) {
			result = this.descriprion.value;
		}

		if (this.data.isRequiredDocument) {
			if (typeof result === 'string') {
				result = { desc: result, documents: this.supporting_docs.value };
			} else if (typeof result === 'object' && result !== null) {
				result.documents = this.supporting_docs.value;
			} else {
				result = { documents: this.supporting_docs.value };
			}
		}

		this.dialogRef.close(result);
	}

	isSubmitDisabled(): boolean {
		if (this.data.requiredRefNo && (this.descriprion.invalid || this.ref_desc.invalid || this.other_desc.invalid)) {
			return true;
		}
		if (this.data.requiredReason && !this.data.requiredRefNo && this.descriprion.invalid) {
			return true;
		}
		if (this.data.isRequiredDocument && this.supporting_docs.invalid) {
			return true;
		}
		return false;
	}

}
